import { Progress } from '@/components/ui/progress'
import { useI18n } from '@/lib/i18n'
import { cn } from '@/lib/utils'

interface ProgressBarProps {
  /** 0-100. Omit (or pass null) for indeterminate mode. */
  value?: number | null
  /** Optional status text shown above the bar, e.g. "Converting…". */
  label?: string
  className?: string
}

/** Labeled progress bar; indeterminate mode animates while duration is unknown. */
export function ProgressBar({ value, label, className }: ProgressBarProps) {
  const indeterminate = value === null || value === undefined
  const { t } = useI18n()

  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">{label ?? t('progressDefault')}</span>
        {!indeterminate && (
          <span className="font-medium tabular-nums">{Math.round(value)}%</span>
        )}
      </div>
      {indeterminate ? (
        <div className="relative h-2 w-full overflow-hidden rounded-full bg-primary/20">
          <div className="absolute inset-y-0 w-1/3 animate-[progress-indeterminate_1.2s_ease-in-out_infinite] rounded-full bg-primary" />
        </div>
      ) : (
        <Progress value={value} />
      )}
    </div>
  )
}
